// ======================================================================
// FILE:
// src/modules/service_crm/feedback/services/serviceFeedbackService.js
//
// MODULE:
// Service CRM
//
// FEATURE:
// Customer Feedback Queue
// ======================================================================

import axiosClient from "../../../../api/axiosClient";


// ======================================================================
// FEEDBACK QUEUE
// ======================================================================

const getFeedbackQueue = async (
  params = {}
) => {

  const res =
    await axiosClient.get(

      "/api/service-crm/feedback",

      {
        params,
      }

    );

  return (
    res.data.data
  );

};


// ======================================================================
// EXPORT
// ======================================================================

const serviceFeedbackService = {

  getFeedbackQueue,

};

export default serviceFeedbackService;